<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5>
          <b-badge :variant="'info'">Assignment Timeline</b-badge>
        </h5>
        <b-button
          v-if="TM_AccordianButton"
          @click="toggleActive()"
          variant="outline-info"
          size="xs"
          style="font-size: 0.675rem"
          class="mt-1"
          >{{ TM_AccordianStatus ? "Hide Timeline" : "Show Timeline" }}</b-button
        >
      </div>
    </div>
    <div class="timeline" v-if="allAssignmentTimelineSummaryData.length > 0  && TM_AccordianStatus">
      <div
        v-for="(post, index) in allAssignmentTimelineSummaryData"
        :key="post.id"
        :class="['timeline-item', index % 2 === 0 ? 'left' : 'right']"
      >
        <div class="timeline-panel">
          <div class="timeline-heading">
            <!-- <h4 class="timeline-title">{{ post.JOBNO }}</h4> -->
            <p class="text-muted">{{ formattedDate(post.assbill_log_createdAt) }}</p>
          </div>
          <div class="timeline-body">
            <p>{{ post.assbill_log_message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClientUserService from "../../services/ClientUserService.js";
export default {
  name: "Timeline",
  props: {
    allModuleId: {
      type: Number,
      required: true,
    },
    TMAccordianStatus: {
      type: Boolean,
      required: false,
    },
    TMAccordianButton: {
      type: Boolean,
      required: false,
    },
  },
  beforeMount() {
    if (this.allModuleId != "") {
      this.getAssignmentTimelineSummary();
    }
  },
  data() {
    return {
      TM_AccordianStatus: this.TMAccordianStatus ? this.TMAccordianStatus : false,
      TM_AccordianButton: this.TMAccordianButton,
      allAssignmentTimelineSummaryData: [],
      all_module_id: this.allModuleId,
      Filter_Flag: false,
    };
  },
  methods: {
    toggleActive() {
      this.TM_AccordianStatus = !this.TM_AccordianStatus;
       this.getAssignmentTimelineSummary();
    },
    getAssignmentTimelineSummary() {
      if (this.allModuleId) {
        let AssignmentSummary = {
          itemCode: "AssignmentTimelineSummary",
          allModuleId: this.allModuleId,
        };
        ClientUserService.getAllOverseaLock(JSON.stringify(AssignmentSummary))
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.allAssignmentTimelineSummaryData.length > 0) {
                this.allAssignmentTimelineSummaryData =
                  data.allAssignmentTimelineSummaryData;
              }
            }
          })
          .catch((error) => {
            console.log("Catch on getAssignmentTimelineSummary Error: ", error);
          });
      }
    },
    formattedDate(dateString) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const date = new Date(dateString);
      return date.toLocaleDateString(undefined, options);
    },
  },
};
</script>

<style>
.timeline {
  position: relative;
  padding: 5px 0;
}

.timeline:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #17a2b8; /* Change this to your desired color */
  left: 50%;
  margin-left: -2px;
}

.timeline-item {
  margin-bottom: 5px;
  position: relative;
  display: flex;
  flex-direction: row;
}

.timeline-item.right {
  justify-content: end;
}

.timeline-badge {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  text-align: center;
  position: absolute;
  top: 0;
  border: 2px solid #fff;
}

.timeline-badge img {
  width: 100%;
  height: 100%;
}

.timeline-panel {
  /* flex: 1; */
  width: 50%;
  border: 2px solid #17a2b8;
  position: relative;
  border-radius: 5px;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #333;
}

.timeline-heading {
  margin-bottom: 10px;
}

.timeline-title {
  font-weight: bold;
  margin-bottom: 5px;
  color: #17a2b8; /* Change this to your desired color */
}

.timeline-body {
  margin-bottom: 10px;
}

.text-muted {
  color: #777;
}

/* Timeline cards on the right side */
.timeline-item.right .timeline-panel {
  margin-left: 30px;
}

/* Optional: Add hover effect */
.timeline-panel:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}
</style>



// WEBPACK FOOTER //
// assignmentTimeline.vue?5ce87d88